import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import uk from './locales/uk.json';
import ru from './locales/ru.json';

const resources = {
    en: { translation: en },
    uk: { translation: uk },
    ru: { translation: ru },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'uk',
        interpolation: {
            escapeValue: false,
        },
        fallbackLng: 'uk'
    });

export default i18n;